import React from 'react';
import styled from 'styled-components';
import { StyledButton as Button } from '../../CommonComponents/Button';
import FilterModal from '../../CommonComponents/ModalListPicker';
import Icon from '../../CommonComponents/Icon';
import { DEFAULT_ACCOUNT_ID, DEFAULT_PERIOD_ID } from '../../Transactions/TransactionsConstants';

const ListControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  border-bottom: solid 1px #ebe7e7;
  padding: 0 15px 15px 15px;
`;

const StyledButton = styled(Button)`
  background: #e7e7e7;
  color: #000000;
  padding: 13px 20px;
  font-size: 14px;
  text-align: left;
  flex-basis: 0;

  &:not(.disabled):hover,
  &:not(.disabled):focus,
  &:not(.disabled):active {
    background: #e7e7e7;
    color: #000000;
  }

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  & + & {
    margin-left: 2px;
  }
`;

const FilterButton = styled(StyledButton)`
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
`;

const SearchButton = styled(StyledButton)`
  width: 20%;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  text-align: center;

  ${Icon} {
    color: #0447fa;
  }
`;

class ListControls extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFilterModalOpen: false,
      filter: null,
      filterModal: {
        options: [],
        value: null,
        defaultValue: null,
      },
    };

    this.closeModal = this.closeModal.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  onFilterChange(value) {
    const { onAccountChange, onPeriodChange } = this.props;

    const { filter } = this.state;

    switch (filter) {
      case 'account':
        onAccountChange({ accountId: value });
        break;
      case 'period':
        onPeriodChange({ periodId: value });
        break;
      default:
    }

    this.closeModal();
  }

  closeModal() {
    this.setState({ isFilterModalOpen: false });
  }

  openFilterModal(filter, options, value, defaultValue) {
    this.setState({
      isFilterModalOpen: true,
      filter,
      filterModal: {
        options,
        value,
        defaultValue,
      },
    });
  }

  render() {
    const {
      accounts,
      periodOptions,
      currentAccountId,
      currentPeriodId,
      onSearchClick,
    } = this.props;

    const { label: currentPeriodLabel } = periodOptions.find(period => period.value === currentPeriodId);
    const { label: currentAccountLabel } = accounts.find(account => account.value === currentAccountId);

    return (
      <ListControlsWrapper>
        <FilterButton
          onClick={() =>
            this.openFilterModal('account', accounts, currentAccountId, DEFAULT_ACCOUNT_ID)
          }
        >
          {currentAccountLabel}
        </FilterButton>

        <FilterButton
          onClick={() =>
            this.openFilterModal('period', periodOptions, currentPeriodId, DEFAULT_PERIOD_ID)
          }
        >
          {currentPeriodLabel}
        </FilterButton>

        <SearchButton onClick={onSearchClick}>
          <Icon className="fa fa-search" />
        </SearchButton>

        <FilterModal
          hasHeader
          title="FILTER BY:"
          isOpen={this.state.isFilterModalOpen}
          onRequestClose={this.closeModal}
          options={this.state.filterModal.options}
          value={this.state.filterModal.value}
          defaultValue={this.state.filterModal.defaultValue}
          onChange={this.onFilterChange}
        />
      </ListControlsWrapper>
    );
  }
}

export default ListControls;
